var React = require('react');

function Angular (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"simpleicons-angular-icon","key":0},"Angular icon"),React.createElement("path",{"d":"M9.93 12.645h4.134L11.996 7.74","key":1}),React.createElement("path",{"d":"M11.996.009L.686 3.988l1.725 14.76 9.585 5.243 9.588-5.238L23.308 3.99 11.996.01zm7.058 18.297h-2.636l-1.42-3.501H8.995l-1.42 3.501H4.937l7.06-15.648 7.057 15.648z","key":2})]);
}

Angular.displayName = "Angular";

Angular.defaultProps = {"aria-labelledby":"simpleicons-angular-icon","role":"img","viewBox":"0 0 24 24"};

module.exports = Angular;

Angular.default = Angular;



//////////////////
// WEBPACK FOOTER
// ./src/images/inline-svg/angular.svg
// module id = 867
// module chunks = 35783957827783